import React, { useContext } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useBankAccountTypeService from '../../../app/services/hooks/useBankAccountType';

interface Props {
    bankAccountTypeId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const BankAccountTypeAccountTypeSwitchChange = ({
    bankAccountTypeId,
    checkValue,
    callbackSuccess
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeBankAccountType, fetchingActiveBankAccountType } = useBankAccountTypeService();

    const active = (value: boolean) => {
        setChecked(value);

        activeBankAccountType(bankAccountTypeId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={bankAccountTypeId} callback={active} />;
};

export default BankAccountTypeAccountTypeSwitchChange;
